var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",staticStyle:{"line-height":"0.8"}},[(_vm.keepAlive)?_c('keep-alive',[(_vm.keepAlive)?_c('router-view'):_vm._e()],1):_vm._e(),(!_vm.keepAlive)?_c('router-view'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }